import React, { FC, ReactNode } from 'react';

import { StyledBlock } from './styled';

/** Passed to `MainMenuItemWrapper` when a community row is non-interactive as a link. */
export type MainMenuItemDisableReason =
  | 'none'
  | 'blocked'
  | 'subscriptionSlotInactive';

interface MainMenuItemWrapperProps {
  children: ReactNode;
  to: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  /** When `isDisabled` is true, controls ring/badge styling. */
  disableReason?: MainMenuItemDisableReason;
  'aria-label'?: string;
}

const MainMenuItemWrapper: FC<MainMenuItemWrapperProps> = ({
  children,
  to,
  isDisabled = false,
  isSelected,
  disableReason = 'none',
  'aria-label': ariaLabel,
}) => (
  <StyledBlock
    to={to}
    $isDisabled={isDisabled}
    $isSelected={isSelected}
    $disableReason={disableReason}
    aria-label={ariaLabel}
  >
    {children}
  </StyledBlock>
);

export default MainMenuItemWrapper;
